import { queryOptions } from '@tanstack/react-query'
import { api } from '@/api/client'
import { STALE_TIME_LONG } from '@/lib/constants'
import { queryKeys } from '@/lib/query-keys'

export interface OrganisationOperatorMachine {
  code: string
  name: string
}

export interface OrganisationOperator {
  id: number
  first_name: string
  last_name: string
  email: string
  machines: OrganisationOperatorMachine[]
}

export interface CreateOrganisationOperatorData {
  first_name: string
  last_name: string
  email: string
  email_optin?: boolean
  machine_ids: number[]
}

export async function fetchOrganisationOperators(
  organisationId: number,
  params?: { search?: string },
): Promise<OrganisationOperator[]> {
  const response = await api.get<{ data: OrganisationOperator[] }>(
    `/organisations/${organisationId}/operators`,
    { params },
  )
  return response.data
}

export async function createOrganisationOperator(
  organisationId: number,
  data: CreateOrganisationOperatorData,
): Promise<{ message: string; data: OrganisationOperator }> {
  return api.post<{ message: string; data: OrganisationOperator }>(
    `/organisations/${organisationId}/operators`,
    { body: data },
  )
}

export function organisationOperatorsQueryOptions(
  organisationId: number,
  params?: { search?: string },
) {
  return queryOptions({
    queryKey: queryKeys.organisationOperators.list(organisationId, params),
    queryFn: async () => fetchOrganisationOperators(organisationId, params),
    staleTime: STALE_TIME_LONG,
  })
}
